import Vue from 'vue';
import FeatherIcon from '@core/components/feather-icon/FeatherIcon.vue';

import BInputNumber from '@/components/common/BInputNumber/BInputNumber.vue';
import {
    ValidationProvider,
    ValidationObserver,
} from 'vee-validate';

import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import VueSelect from '@/components/VueSelect/index';
import Flatpickr from 'vue-flatpickr-component/src/index';

import {
    faLaptopHouse,
    faCubes,
    faBomb,
    faSignOutAlt,
    faFolderOpen,
    faNetworkWired,
    faLaptopCode,
    faServer,
    faDesktop,
    faHardHat,
    faHistory,
    faQuestionCircle,
    faCheckCircle,
    faInfoCircle,
    faExclamationCircle,
    faCheckSquare,
    faEdit,
    faQrcode,
    faUserCog,
} from '@fortawesome/free-solid-svg-icons';
import {
    faPaperPlane,
    faWindowMaximize,
    faIdBadge,
    faAddressBook,
    faWindowRestore,
} from '@fortawesome/free-regular-svg-icons';

import XEUtils from 'xe-utils';
import { VXETable, Header, Table, Column, Pager, Grid, Icon } from 'vxe-table';
import zhCN from 'vxe-table/lib/locale/lang/zh-CN'
import enUS from 'vxe-table/lib/locale/lang/en-US'

import {
    BootstrapVue,
} from 'bootstrap-vue';

Vue.component(FeatherIcon.name, FeatherIcon);
Vue.component('BInputNumber', BInputNumber);
Vue.component('FontAwesomeIcon', FontAwesomeIcon);
Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
Vue.component('VSelect', VueSelect);
Vue.component('VFlatpickr', Flatpickr);

Vue.use(BootstrapVue);

library.add(
    faLaptopHouse,
    faCubes,
    faBomb,
    faSignOutAlt,
    faFolderOpen,
    faWindowRestore,
    faNetworkWired,
    faLaptopCode,
    faServer,
    faDesktop,
    faHardHat,
    faHistory,
    faQuestionCircle,
    faCheckCircle,
    faInfoCircle,
    faExclamationCircle,
    faCheckSquare,
    faPaperPlane,
    faWindowMaximize,
    faIdBadge,
    faAddressBook,
    faEdit,
    faQrcode,
    faUserCog
);

Vue.use(Header)
    .use(Column)
    .use(Table)
    .use(Pager)
    .use(Grid)
    .use(Icon);

export const initVXETableLocale = (locale) => {
    const lang = locale === 'cn' ? zhCN : enUS
    VXETable.setup({
        i18n: (key, args) => {
            return XEUtils.toFormatString(XEUtils.get(lang, key), args)
        },
    })
}
